module.exports = __webpack_public_path__ + "static/media/1.e9837c49.png";